import React from "react";
import { CheckCircle2, ChevronRight } from "lucide-react";
import { CapIcon } from "./CapIcon";

export const ProgressHeader = ({ aprobadas, total, title, subtitle }) => {
  const pct = total ? Math.round((aprobadas / total) * 100) : 0;
  return (
    <div data-testid="cap-progress-header">
      <div className="text-[11px] font-extrabold tracking-[0.3em] text-[var(--gold)]">SUPERA LEADERSHIP ACADEMY</div>
      <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-white leading-tight">{title}</h1>
      {subtitle && <p className="mt-3 text-white/70 max-w-2xl">{subtitle}</p>}
      <div className="mt-6 max-w-xl">
        <div className="flex justify-between text-xs font-bold text-white/70 mb-2">
          <span data-testid="cap-progress-count">{aprobadas} de {total} módulos aprobados</span><span>{pct}%</span>
        </div>
        <div className="h-2.5 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full bg-[var(--gold)] rounded-full transition-[width] duration-700" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
};

export const ModuleGrid = ({ items, isDone, onOpen }) => (
  <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="cap-module-grid">
    {items.map((c, i) => {
      const done = isDone(c);
      return (
        <button key={c.id} data-testid={`cap-card-${i + 1}`} onClick={() => onOpen(c)}
          style={{ animationDelay: `${i * 40}ms` }}
          className="group text-left rounded-3xl bg-white/[0.06] ring-1 ring-white/10 hover:ring-[var(--gold)] hover:bg-white/[0.09] p-5 transition-colors animate-in fade-in slide-in-from-bottom-2 fill-mode-both">
          <div className="flex items-center gap-3">
            <span className="text-3xl font-extrabold text-white/15">{String(c.orden || i + 1).padStart(2, "0")}</span>
            <span className="w-11 h-11 rounded-2xl bg-white/10 flex items-center justify-center"><CapIcon name={c.icono} className="w-5 h-5 text-[var(--gold)]" /></span>
            {done ? <CheckCircle2 className="ml-auto w-6 h-6 text-[#3DDC84]" data-testid={`cap-card-done-${i + 1}`} />
              : <span className="ml-auto text-[10px] font-extrabold tracking-widest text-white/50">PENDIENTE</span>}
          </div>
          <div className="mt-4 font-extrabold text-white">{c.titulo}</div>
          <div className="mt-1 text-sm text-white/60 line-clamp-2">{c.resumen}</div>
          <div className="mt-4 inline-flex items-center gap-1 text-xs font-bold text-[var(--gold)]">
            {done ? "Repasar" : "Comenzar"} <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </div>
        </button>
      );
    })}
  </div>
);
